import { parseAuthReturnTo } from '../../server/auth/contracts.js';

export interface BrowserLocationPath {
  pathname: string;
  search: string;
  hash?: string;
}

/** Reject unexpected browser URL state instead of reflecting it into a login attempt. */
export function authReturnToFromLocation(location: BrowserLocationPath): string {
  if ((location.pathname === '/decks'
      || location.pathname === '/challenges'
      || /^\/decks\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/u
        .test(location.pathname))
    && location.search === ''
    && (location.hash ?? '') === '') {
    return location.pathname === '/challenges' ? '/challenges' : '/decks';
  }
  try {
    if ((location.hash ?? '') !== '') throw new Error('fragment запрещён');
    return parseAuthReturnTo(`${location.pathname}${location.search}`);
  } catch {
    return '/';
  }
}
